import { 
  MdRequestQuote, 
  MdListAlt, 
  MdLocalShipping, 
  MdReceipt, 
  MdAccountBalance, 
  MdAttachMoney, 
  MdAdd, 
  MdOutlineReceiptLong,
  MdPayments
} from "react-icons/md";

const ventas = {
  id: 'ventas-group',
  type: 'group',
  roles: [1,100,110,400,500,300],
  breadcrumbs: false,
  children: [
    {
      id: 'ventas',
      title: "Ventas",
      type: 'collapse',
      icon: MdOutlineReceiptLong,
      children: [
        {
          id: 'nueva-cotizacion',
          title: "Nueva cotización",
          type: 'item',
          breadcrumbs: false,
          icon: MdAdd,
          url: '/ventas/nueva-cotizacion',
          roles: [1,400,500]
        },
        {
          id: 'cotizaciones',
          title: "Cotizaciones",
          type: 'item',
          breadcrumbs: false,
          icon: MdRequestQuote,
          url: '/ventas/cotizaciones',
          roles: [1,100,110,400,500]
        },
        {
          id: 'pedidos-venta',
          title: "Pedidos",
          type: 'item',
          breadcrumbs: false,
          icon: MdListAlt,
          url: '/ventas/pedidos-venta',
          roles: [1,100,110,400,500,300]
        },
        {
          id: 'remisiones',
          title: "Remisiones",
          type: 'item',
          breadcrumbs: false,
          icon: MdLocalShipping,
          url: '/ventas/remisiones',
          roles: [1,100,110,200,400,300]
        },
        {
          id: 'facturas',
          title: "Facturas",
          type: 'item',
          breadcrumbs: false,
          icon: MdReceipt,
          url: '/ventas/facturas',
          roles: [1,100,110,500,300]
        },
        /*{
          id: 'notas-credito',
          title: "Notas de Crédito",
          type: 'item',
          breadcrumbs: false,
          icon: MdNote,
          url: '/ventas/notas-credito',
          roles: [1,100,110]
        },*/
        {
          id: 'CxC',
          title: "Cuentas por Cobrar",
          type: 'item',
          breadcrumbs: false,
          icon: MdAccountBalance,
          url: '/ventas/CxC',
          roles: [1,100,110,200,400,500]
        },
        {
          id: 'cobros',
          title: "Cobros",
          type: 'item',
          breadcrumbs: false,
          icon: MdPayments,
          url: '/ventas/cobranza',
          roles: [1,100,110,400]
        },
        {
          id: 'listas-precios',
          title: "Listas de Precios",
          type: 'item',
          breadcrumbs: false,
          icon: MdAttachMoney,
          url: '/ventas/listas-precios',
          roles: [1,100,110,400,500]
        }
      ]
    }
  ]
};

export default ventas;
